import is from 'typescript-styled-is'
import styled from '../../../../theme'

const DateLabel = styled.div<IDateLabel>`
  font-weight: bold;
  margin: 0px ${({ size }) => (size ? 3 * size : 3)}px;
  ${is('red')`
		color: red;
	`};
`
export default DateLabel

export interface IDateLabel {
  red?: boolean
  size?: number
}
